import { addYears, differenceInDays } from "date-fns";

import { JOHN_CAREER, type CareerJob } from './Career';
import VerticalTimeline, { VerticalTimelineEntry } from '../components/VerticalTimeline';

const CONTENT_STYLE = { color: '#151045' };
const ICON_STYLE = { background: '#151045' };

const now = new Date();

const averageTenureLengthInDaysAtDate = (jobs: CareerJob[], cutoffDate: Date):number => {
  const cutoffTime = cutoffDate.getTime();
  const jobsUpToDate = jobs.filter((job) => job.startDate.getTime() < cutoffTime);

  if (jobsUpToDate.length === 0) { 
    return 0;
  }

  const totalDays = differenceInDays(cutoffDate, jobsUpToDate[0]!.startDate);
  return totalDays / jobsUpToDate.length;
}

const averageTenureDays = averageTenureLengthInDaysAtDate(JOHN_CAREER, now);

const FIRST_YEAR_ANNIVERSARY = addYears(JOHN_CAREER[0].startDate, 1);
const END_ANNIVERSARY = addYears(now, 1);

const yearlyAverageTenures = [];
for (let yr = FIRST_YEAR_ANNIVERSARY; yr <= END_ANNIVERSARY; yr = addYears(yr, 1)) {

  yearlyAverageTenures.push(
    { 
        year: yr,
        avg: averageTenureLengthInDaysAtDate(JOHN_CAREER, yr)
      }
  );
}

// https://github.com/stephane-monnot/react-vertical-timeline
// Would like the round dots to become elongated and to allow multiple overlapping
// elements, but hey...
export const Timeline = () => {
  return (
    <>
      <div>
        <h3>Average tenure length (days) 
          <strong>{averageTenureDays} ({averageTenureDays / 365} years)</strong>
        </h3>
        <h5>
          {JSON.stringify(yearlyAverageTenures, null, 2)}
        </h5>
      </div>
      <VerticalTimeline lineColor='#151045'>
        { JOHN_CAREER.map((careerJob) => 
          <VerticalTimelineEntry 
            averageDurationAtEndDate={averageTenureLengthInDaysAtDate(JOHN_CAREER, careerJob.endDate || new Date())}
            startDate={careerJob.startDate} 
            endDate={careerJob.endDate}
          >
            <>
            <h3 className="vertical-timeline-element-title">{careerJob.companyName}</h3>
            <h4 className="vertical-timeline-element-subtitle">{careerJob.location}</h4>
            <p>
              {careerJob.techologies.map((t) => t.name).join(", ")}
            </p>
              </>
          </VerticalTimelineEntry>
        )
      }
      </VerticalTimeline>
    </>
  )
}
